import React from 'react';
import { Carousel } from 'antd';
import { css } from '@emotion/css';
import { AUTH_SLIDES } from '../consts/authSlides';

// --- Styles ---

const wrapperStyle: React.CSSProperties = {
  width: '100%',
  borderRadius: 20,
  overflow: 'hidden',
  position: 'relative',
  boxShadow: '0 2px 16px rgba(0, 0, 0, 0.1)',
};

const carouselClass = css`
  height: 100%;
  .ant-carousel,
  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide,
  .slick-slide > div {
    height: 100%;
  }
  .slick-dots {
    bottom: 24px !important;
    li {
      button {
        background: rgba(255, 255, 255, 0.5) !important;
        border-radius: 4px !important;
        height: 4px !important;
      }
      &.slick-active button {
        background: #fff !important;
      }
    }
  }
`;

const imgStyle: React.CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'left center',
  display: 'block',
};

const overlayStyle: React.CSSProperties = {
  position: 'absolute',
  inset: 0,
  background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.15) 45%, transparent 70%)',
  borderRadius: 20,
};

// --- Component ---

interface AuthCarouselProps {
  height: string;
  compact?: boolean;
}

export const AuthCarousel: React.FC<AuthCarouselProps> = ({ height, compact }) => (
  <div style={{ ...wrapperStyle, height }} className={carouselClass}>
    <Carousel autoplay autoplaySpeed={5000} dots speed={600}>
      {AUTH_SLIDES.map((slide, i) => (
        <div key={i}>
          <div style={{ position: 'relative', height }}>
            <img
              src={slide.image}
              alt=""
              style={imgStyle}
              loading={i === 0 ? 'eager' : 'lazy'}
              fetchPriority={i === 0 ? 'high' : 'low'}
            />
            <div style={overlayStyle} />
            <div
              style={{
                position: 'absolute',
                bottom: compact ? 40 : 52,
                left: 0,
                right: 0,
                padding: compact ? '0 24px' : '0 40px',
                color: '#fff',
              }}>
              <div
                style={{
                  fontSize: compact ? 20 : 28,
                  fontWeight: 700,
                  lineHeight: 1.25,
                  marginBottom: compact ? 6 : 10,
                  letterSpacing: '-0.02em',
                }}>
                {slide.title}
              </div>
              <div
                style={{
                  fontSize: compact ? 13 : 15,
                  lineHeight: 1.55,
                  opacity: 0.85,
                  maxWidth: 460,
                }}>
                {slide.subtitle}
              </div>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  </div>
);
